module.exports = __webpack_public_path__ + "static/media/bulkTick.f5aacfb7.svg";